import {Component, ElementRef, Inject, inject, OnInit, ViewChild} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {BaseComponent} from "../common/BaseComponent";
import {CustomerProductItemDetailComponent} from "./customerProductItemDetail/customerProductItemDetail.component";
import {FormControl} from "@angular/forms";
import {Customer} from "../../Models/Customer/Customer";
import {map, Observable, startWith} from "rxjs";
import {Clipboard} from '@angular/cdk/clipboard';
import {MatTableDataSource} from "@angular/material/table";
import {SpringRestService} from "@aiknow-srl/aik-angular-sdk";
import {CustomerService} from "../../Services/Ope/Customer.service";
import {CustomerProductItemService} from "../../Services/Ope/CustomerProductItem.service";
import {GetAllCustomersCB} from "../../Ope/Customer/GetAllCustomersCB";
import {PageEvent} from "@angular/material/paginator";
import {GetCustomerProductItemsCB} from "../../Ope/CustomerProductItem/GetCustomerProductItemsCB";
import {PutCustomerProductItemCB} from "../../Ope/CustomerProductItem/PutCustomerProductItemCB";
import {DAEAttributesDTO} from "../../Models/CustomerProductItem/DAEAttributesDTO";
import {E015Attributes} from "../../Models/CustomerProductItem/E015Attributes";
import {DelCustomerProductItemCB} from "../../Ope/CustomerProductItem/DelCustomerProductItemCB";
import {GetProductItemTokenCB} from "../../Ope/CustomerProductItem/GetProductItemTokenCB";
import {GetCustomerProductItemAttributesCB} from "../../Ope/CustomerProductItem/GetCustomerProductItemAttributesCB";
import {RegistryStatusEnum} from "./registryStatusEnum";
import {PutCustomerProductItemOnOSMCB} from "../../Ope/CustomerProductItem/PutCustomerProductItemOnOSMCB";
import {BaseDialogComponent} from "../common/BaseDialogComponent";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ChangeProductItemOwnerCB} from "../../Ope/CustomerProductItem/ChangeProductItemOwnerCB";
import {
PutCustomerProductItemRegistryStatusCB
} from "../../Ope/CustomerProductItem/PutCustomerProductItemRegistryStatusCB";
import {ChangeProductItemTokenCB} from "../../Ope/CustomerProductItem/ChangeProductItemTokenCB";
import {CustomerProductItem} from "../../Models/CustomerProductItem/CustomerProductItem";
import {CustomerProductItemFull} from "../../Models/CustomerProductItem/CustomerProductItemFull";
import {GetAllProductTypesCB} from "../../Ope/ProductType/GetAllProductTypesCB";
import {ProductType} from "../../Models/CustomerProductItem/ProductType";
import {ProductTypeService} from "../../Services/Ope/ProductType.service";
import {ProductTypeChargerRelationDTO} from "../../Ope/ProductType/ProductTypeChargerRelationDTO";
import {GetAllChargersCB} from "../../Ope/Charger/GetAllChargersCB";
import {ChargerService} from "../../Services/Ope/Charger.service";
import {toNumbers} from "@angular/compiler-cli/src/version_helpers";


@Component({
selector: 'app-customer-productItems-registry',
templateUrl: './customerProductItemRegistry.component.html',
styleUrls: ['./customerProductItemRegistry.component.css', '../common/drawer-style.css'],
animations: [
trigger('detailExpand', [
state('collapsed', style({height: '0px', minHeight: '0'})),
state('expanded', style({height: '*'})),
transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
])
]
})
export class CustomerProductItemRegistryComponent extends BaseComponent implements OnInit {

  @ViewChild(CustomerProductItemDetailComponent) customerProductItemDetail?: CustomerProductItemDetailComponent;

// ***************************
//   PAGINATION OPTIONS
// ***************************
  readonly PAGESIZE_OPTIONS = [10, 20, 30];
  totalPages?: number;
  totalElements?: number;
  page = 0;
  pageSize = this.PAGESIZE_OPTIONS[0];

  customerSelectionControl = new FormControl('');
  allCustomers?: Customer[];
  filteredCustomers!: Observable<Customer[]>;
  selectedCustomer?: Customer;

  productItems?: CustomerProductItem[];
  expandedElementDetailed?: CustomerProductItemFull;

  newProductItem?: CustomerProductItemFull;
  displayedColumns: string[] = ['name', 'label', 'daeFeature', 'e015Feature', 'registryStatus', 'monitored', 'actions'];
  tableDataSource!: MatTableDataSource<CustomerProductItem>;

  editMode = false;
  formValidationOk = true;
  isOnChirpstack!: boolean;
  productItemNameToFind?: string;

  customerProductItemsLoading = false;
  searchEnabled = false;
  filterValueSearch = '';


  private be = inject(SpringRestService);
  private clipboard = inject(Clipboard);
  public customerService = inject(CustomerService);
  private customerProductItemService = inject(CustomerProductItemService);
  private productTypeService = inject(ProductTypeService);

  ngOnInit(): void {
    this.getAllCustomers();
  }

  private _filter(value: string): Customer[] {
    const filterValue = value.toLowerCase();
    return this.allCustomers!.filter(customer => customer.title.toLowerCase().includes(filterValue));
  }

  displayFn(customer: Customer): string {
    return customer ? customer.title : '';
  }


  clearSelection() {
    this.customerSelectionControl.patchValue("");
    this.selectedCustomer = undefined;
    this.productItems = undefined;
  }

  getAllCustomers() {
    const cb = new GetAllCustomersCB();

    this.customerService.getAllCustomers(cb).subscribe(
        () => {
          this.allCustomers = cb.o.customers.sort((a, b) => a.title.localeCompare(b.title));
          this.filteredCustomers = this.customerSelectionControl.valueChanges.pipe(
              startWith(''),
              map(value => {
                if(!value){
                  return  this.allCustomers!.slice();
                }
                const title = typeof value === 'string' ? value : (value as unknown as Customer).title;
                return title ? this._filter(title as string) : this.allCustomers!.slice()
              }),
          );
        }, error => {
          this.gmService.openErrorSnackbar(error);
        }
    );
  }

  /**
   * listen to Paginator event
   */
  public getPaginatorData(event: PageEvent): PageEvent {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getCustomerProductItems();
    return event;
  }


  getCustomerProductItems() {
    if (!!this.selectedCustomer) {
      this.customerProductItemsLoading = true;
      this.tableDataSource = new MatTableDataSource<CustomerProductItem>();

      const cb = new GetCustomerProductItemsCB();
      cb.i.customerId = this.selectedCustomer!.id;
      cb.i.pageSize = this.pageSize;
      cb.i.page = this.page;
      cb.i.textSearch = (!!this.productItemNameToFind && this.productItemNameToFind != '') ? this.productItemNameToFind : undefined;

      this.customerProductItemService.getCustomerProductItems(cb).subscribe(
          () => {
            this.productItems = cb.o.productItems.sort((a, b) => {
              if (a.isMonitored === b.isMonitored) {
                return a.name.localeCompare(b.name)
              }

              if (a.isMonitored) {
                return -1;
              }

              if (b.isMonitored) {
                return 1;
              }
              return 0
            });
            this.totalElements = cb.o.totalElements;
            this.totalPages = cb.o.totalPages;
            this.tableDataSource = new MatTableDataSource<CustomerProductItem>(this.productItems);

            this.customerProductItemsLoading = false;

// Update the Expanded element
            if (!!this.expandedElementDetailed) {
              this.showDetail(this.expandedElementDetailed, true);
            } else {
              this.editMode = false;
            }
          }, (error: string) => {
            this.gmService.openErrorSnackbar(error);
            this.tableDataSource = new MatTableDataSource<CustomerProductItem>();
            this.customerProductItemsLoading = false;
          }
      );
    }

  }

  changeWorkflowStatus(element: CustomerProductItemFull) {


    const dialogRef = this.dialog.open(ChangeWorkflowStatusDialogComponent, {
      width: '600px',
      data: element
    });

    dialogRef.afterClosed().subscribe(
        (res) => {
          if (!!res) {
            this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.CHANGE_WORKFLOW_STATUS_OK'));
            this.getCustomerProductItems();
          }
        }, error => {
          console.log(error);
        }
    );
  }


  changeProductItemOwner(element: CustomerProductItem) {
    this.newProductItem = JSON.parse(JSON.stringify(element));

    const dialogRef = this.dialog.open(ChangeCustomerProductItemOwnerDialogComponent, {
      width: '600px',
      data: {
        productItem: this.newProductItem,
        selectedCustomer: this.selectedCustomer,
        allCustomers: this.allCustomers
      }
    });

    dialogRef.afterClosed().subscribe(
        (res) => {
          if (!!res) {
            this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.CHANGE_OWNER_OK'));
            this.getCustomerProductItems();
          }
        }, error => {
          console.log(error);
        }
    );
  }

  updateProductItem() {
    const productItem = this.customerProductItemDetail?.dataDetail;
    const imageFile = this.customerProductItemDetail?.selectedFile;

// CHECK FILE DIMENSION

    if (!!imageFile && imageFile.size > this.gmService.FILE_MAX_SIZE) {
      this.gmService.openErrorSnackbar(this.translate.instant("ERROR.IMAGE_TOO_BIG"));
      return;
    }

    if (!!productItem && !!this.selectedCustomer) {
      const cb = new PutCustomerProductItemCB();

      cb.i.id = productItem.id;
      cb.i.customerId = this.selectedCustomer.id;
      cb.i.name = productItem.name;
      cb.i.label = productItem.label;
      cb.i.latitude = productItem.latitude;
      cb.i.longitude = productItem.longitude;
      cb.i.location = productItem.location;
      cb.i.serialNumber = productItem.serialNumber;
      cb.i.productType = productItem.productType;
      cb.i.note = productItem.note;
      cb.i.hasDae = productItem.hasDae;
      cb.i.isE015 = productItem.isE015;
      cb.i.hasImage = !!imageFile || !!productItem.imageUrl;

      if (productItem.hasDae) {
        cb.i.daeAttributes = new DAEAttributesDTO();
        cb.i.daeAttributes.daeIsMonitored = productItem.daeAttributes.daeIsMonitored;
        cb.i.daeAttributes.daeSerialNumber = productItem.daeAttributes.daeSerialNumber;

        if (!!productItem.daeAttributes.daeBatteryExpireDate) {
          cb.i.daeAttributes.daeBatteryExpireDate = this.gmService.printDateInBeFormat(new Date(productItem.daeAttributes.daeBatteryExpireDate));
        }

        if (!!productItem.daeAttributes.daeElectrodeExpireDate) {
          cb.i.daeAttributes.daeElectrodeExpireDate = this.gmService.printDateInBeFormat(new Date(productItem.daeAttributes.daeElectrodeExpireDate));
        }
      }

      if (productItem.isE015) {
        cb.i.e015Attributes = new E015Attributes();
        cb.i.e015Attributes.providerName = productItem.e015Attributes.providerName;

//====================================================================================================//
//  Controllo Temporaneo nome del ProductItem e Station ID,                                                //
//  Lo Station ID deve essere uguale al nome del ProductItem, altrimenti lo sovrascrivo.                   //
//  Non sarà necessario dal momento in cui tutti gli Station ID saranno aggiornati al nuovo standard  //
//====================================================================================================//
        if (productItem.e015Attributes.stationId === productItem.name) {
          cb.i.e015Attributes.stationId = productItem.e015Attributes.stationId;
        } else {
          cb.i.e015Attributes.stationId = productItem.name
        }

        cb.i.e015Attributes.locationAddressType = productItem.e015Attributes.locationAddressType;
        cb.i.e015Attributes.locationAddress = productItem.e015Attributes.locationAddress;
        cb.i.e015Attributes.locationZipCode = productItem.e015Attributes.locationZipCode;
        cb.i.e015Attributes.locationCity = productItem.e015Attributes.locationCity;
        cb.i.e015Attributes.locationProvince = productItem.e015Attributes.locationProvince;
        cb.i.e015Attributes.locationRegion = productItem.e015Attributes.locationRegion;
        cb.i.e015Attributes.stationAccessibility = productItem.e015Attributes.stationAccessibility;
        cb.i.e015Attributes.isAlwaysAvailable = productItem.e015Attributes.isAlwaysAvailable;
        cb.i.e015Attributes.isFromSustainableEnergy = productItem.e015Attributes.isFromSustainableEnergy;
      }

      cb.i.useChirpstack = productItem.useChirpstack;
      if (productItem.useChirpstack) {
        cb.i.devEui = productItem.devEui!.replace(/:/g, '');
      }

      cb.i.chargers = productItem.chargers.filter(x => x.chargerCount > 0);

      this.customerProductItemService.putCustomerProductItem(cb).subscribe(
          () => {

            if (!!imageFile) {
              this.be.putEntityImage(this.gmService.composePutImageUrl(this.gmService.PUT_PRODUCTITEM_IMAGE_SERVICE), imageFile, productItem.id).subscribe(
                  () => {
                    this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.UPDATE_OK'));
                    this.getCustomerProductItems();

                  }, err1 => {
                    this.gmService.openErrorSnackbar(err1);
                  }
              );
            } else {
              this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.UPDATE_OK'));
              this.getCustomerProductItems();
            }


          }, (error: string) => {
            this.gmService.openErrorSnackbar(error);
          }
      )
    }
  }

  deleteProductItem(row: CustomerProductItem) {
    const dialogRef = this.dialog.open(AreUSureDeleteProductItemDialogComponent, {
      width: '500px',
      data: row.name
    });

    dialogRef.afterClosed().subscribe(
        (res) => {
          if (res) {

            const cb = new DelCustomerProductItemCB();
            cb.i.id = row.id;
            this.customerProductItemService.delCustomerProductItem(cb).subscribe(
                () => {
                  this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.DELETE_OK'));
                  this.getCustomerProductItems();
                }, (error: string) => {
                  this.gmService.openErrorSnackbar(error);
                }
            );


          }
        }, error => {
          console.log(error);
        }
    );
  }

  addNewProductItem() {
    this.newProductItem = new CustomerProductItemFull();
    const cb = new GetAllProductTypesCB();
    this.productTypeService.getAllProductTypes(cb).subscribe(
        () => {

          this.gmService.productTypesEnum = cb.o.productTypes;

          const dialogRef = this.dialog.open(PutCustomerProductItemDialogComponent, {
            width: '600px',
            data: {
              productItem: this.newProductItem,
              customer: this.selectedCustomer
            }
          });

          dialogRef.afterClosed().subscribe(
              (res) => {
                if (res) {
                  this.gmService.openTranslatedSuccessSnackbar('PRODUCTITEM.ADD_OK');
                  this.getCustomerProductItems();
                }
              }, error => {
                console.log(error);
              }
          );

        }, error => {
          console.log(error);
        }
    );

  }

  openProductItemTokenDialog(element: CustomerProductItem) {

    const cb = new GetProductItemTokenCB();
    cb.i.id = element.id;

    this.customerProductItemService.getProductItemToken(cb).subscribe(
        () => {
          const dialogRef = this.dialog.open(ProductItemTokenDialogComponent, {
            width: '600px',
            data: {
              token: cb.o.accessToken,
              productItem: element
            }
          });
        }, (error: string) => {
          this.gmService.openErrorSnackbar(error);
        });


  }

  showDetail(element: CustomerProductItem, skipHiding = false): void {

    if (!skipHiding && !!this.expandedElementDetailed && this.expandedElementDetailed.id === element.id) {
// hideElement
      this.hideElement();
      this.editMode = false;
      return;
    }

    const cb = new GetCustomerProductItemAttributesCB();
    cb.i.id = element.id;

    this.customerProductItemService.getCustomerProductItemAttributes(cb).subscribe(
        () => {
          if (!!cb.o.devEui) {
            cb.o.devEui = cb.o.devEui.replace(/(.{2})/g, '$1:');
            cb.o.devEui = cb.o.devEui.substring(0, cb.o.devEui.length - 1);
            this.isOnChirpstack = true;
          } else {
            this.isOnChirpstack = false;
          }
          if (!!cb.o.allChargers) {
            let tempAllChargers = []
            for (let charger of cb.o.allChargers) {
              let tempCharger = new ProductTypeChargerRelationDTO();
              tempCharger.chargerType = charger;
              tempCharger.chargerCount = 0;
              tempCharger.taIndex = 0;
              tempAllChargers.push(tempCharger);
            }
            let tempChargers =  JSON.parse(JSON.stringify( cb.o.chargers));
            let tempJson = JSON.stringify(tempAllChargers);
            cb.o.chargers = JSON.parse(tempJson);
// this.productTypes[prodType].chargers = Object.assign([],this.allChargers);
            for(let i = 0; i < tempChargers.length; i++){
              let j = cb.o.chargers.findIndex(x => x.chargerType?.id === tempChargers[i].chargerType?.id );
              if(j >= 0) {
                cb.o.chargers[j].chargerCount = tempChargers[i].chargerCount;
                cb.o.chargers[j].taIndex = tempChargers[i].taIndex;
              }
            }
          }

          this.expandedElementDetailed = cb.o;
          this.editMode = false;
        }, (error: string) => {
          this.gmService.openErrorSnackbar(error);
          this.hideElement();
        }
    );

// this.expandedElement = this.expandedElement === element ? undefined : element;
  }

  hideElement() {
    this.expandedElementDetailed = undefined;
  }

  manageFormValidation($event: boolean) {
    this.formValidationOk = $event;
  }

  enableSearch() {
    this.searchEnabled = true;

  }


  daInstallareElement(el: CustomerProductItem) {
    return el.registryStatus === RegistryStatusEnum.DA_INSTALLARE;
  }

  inCollaudoElement(el: CustomerProductItem) {
    return el.registryStatus === RegistryStatusEnum.IN_COLLAUDO;
  }

  operativoElement(el: CustomerProductItem) {
    return el.registryStatus === RegistryStatusEnum.OPERATIVO;
  }

  getClassForWorkflowStatusIcon(element: any): string {
    if (this.daInstallareElement(element)) {
      return 'daInstallareStatus';
    } else if (this.inCollaudoElement(element)) {
      return 'inCollaudoStatus';
    } else if (this.operativoElement(element)) {
      return 'operativoStatus';
    } else {
      return '';
    }
  }

  publishToOSM(element: CustomerProductItem) {
    const cb = new PutCustomerProductItemOnOSMCB();
    cb.i.id = element.id;
    this.customerProductItemService.putCustomerProductItemOnOSM(cb).subscribe(
        () => {

          this.gmService.openTranslatedSuccessSnackbar('PRODUCTITEM.PUBLISHED_TO_OSM_OK');
          this.getCustomerProductItems();

        }, (error: string) => {
          this.gmService.openErrorSnackbar(error);
        }
    );
  }

  getYesNoIconClass(element: boolean) {
    return element ? 'checkIcon' : 'xIcon';
  }

}


/*--------------------------------
PUT CUSTOMER PRODUCTITEM COMPONENT
-------------------------------*/

@Component({
templateUrl: 'put-customer-product-item-dialog.html',
selector: 'app-put-customer-productItem-dialog',
styleUrls: ['../common/dialog-style.css']
})
export class PutCustomerProductItemDialogComponent extends BaseDialogComponent<PutCustomerProductItemDialogComponent> {

  disableLocationLatLon = false;

  expireBatteryDate?: Date | null;

  expireElectrodeDate?: Date | null;

  selectedFile?: File;

  @ViewChild('fileInput') fileInput!: ElementRef;

  private be = inject(SpringRestService);
  private customerProductItemService = inject(CustomerProductItemService);
  EUIRegex = /(?=^.{0,16}$)[0-9A-Fa-f]{16}|[0-9A-Fa-f}:]{22}[0-9A-Fa-f}]/g

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    data.productItem.latitude = 45.791034974221226;
    data.productItem.longitude = 9.832401500075807;
  }

  onFileSelected(fileEvent: any) {

    this.selectedFile = fileEvent.target.files[0];
  }

  resetImage() {
    this.selectedFile = undefined;
    this.fileInput.nativeElement.value = '';
  }

  updateStationId() {
    this.data.productItem.e015Attributes.stationId = this.data.productItem.name
  }

  saveCustomerProductItem() {

// CHECK FILE DIMENSION

    if (!!this.selectedFile && this.selectedFile.size > this.gmService.FILE_MAX_SIZE) {
      this.gmService.openErrorSnackbar(this.translate.instant("ERROR.IMAGE_TOO_BIG"));
      return;
    }

    const cb = new PutCustomerProductItemCB();

    cb.i.id = this.data.productItem.id;
    cb.i.customerId = this.data.customer.id;
    cb.i.name = this.data.productItem.name;
    cb.i.label = this.data.productItem.label;
    cb.i.latitude = this.data.productItem.latitude;
    cb.i.longitude = this.data.productItem.longitude;
    cb.i.location = this.data.productItem.location;
    cb.i.serialNumber = this.data.productItem.serialNumber;
    cb.i.productType = this.data.productItem.productType;
    cb.i.note = this.data.productItem.note;
    cb.i.hasDae = this.data.productItem.hasDae;
    cb.i.isE015 = this.data.productItem.isE015;
    cb.i.hasImage = !!this.selectedFile;
    cb.i.useChirpstack = this.data.productItem.useChirpstack;
    if (this.data.productItem.useChirpstack) {
      cb.i.devEui = this.data.productItem.devEui.replace(/:/g, '');
    }
    if (this.data.productItem.hasDae) {
      cb.i.daeAttributes = new DAEAttributesDTO();
      cb.i.daeAttributes.daeIsMonitored = this.data.productItem.daeAttributes.daeIsMonitored;
      cb.i.daeAttributes.daeSerialNumber = this.data.productItem.daeAttributes.daeSerialNumber;

      cb.i.daeAttributes.daeBatteryExpireDate = this.gmService.printDateInBeFormat(this.data.productItem.daeAttributes.daeBatteryExpireDate);
      cb.i.daeAttributes.daeElectrodeExpireDate = this.gmService.printDateInBeFormat(this.data.productItem.daeAttributes.daeElectrodeExpireDate);
    }

    if (this.data.productItem.isE015) {
      cb.i.e015Attributes = new E015Attributes();
      cb.i.e015Attributes.providerName = this.data.productItem.e015Attributes.providerName;
      cb.i.e015Attributes.stationId = this.data.productItem.e015Attributes.stationId;
      cb.i.e015Attributes.locationAddressType = this.data.productItem.e015Attributes.locationAddressType;
      cb.i.e015Attributes.locationAddress = this.data.productItem.e015Attributes.locationAddress;
      cb.i.e015Attributes.locationZipCode = this.data.productItem.e015Attributes.locationZipCode;
      cb.i.e015Attributes.locationCity = this.data.productItem.e015Attributes.locationCity;
      cb.i.e015Attributes.locationProvince = this.data.productItem.e015Attributes.locationProvince;
      cb.i.e015Attributes.locationRegion = this.data.productItem.e015Attributes.locationRegion;
      cb.i.e015Attributes.stationAccessibility = this.data.productItem.e015Attributes.stationAccessibility;
      cb.i.e015Attributes.isAlwaysAvailable = this.data.productItem.e015Attributes.isAlwaysAvailable;
      cb.i.e015Attributes.isFromSustainableEnergy = this.data.productItem.e015Attributes.isFromSustainableEnergy;

    }

    this.customerProductItemService.putCustomerProductItem(cb).subscribe(
        () => {
          if (!!this.selectedFile && !!cb.o.id) {
            this.be.putEntityImage(this.gmService.composePutImageUrl(this.gmService.PUT_PRODUCTITEM_IMAGE_SERVICE), this.selectedFile, cb.o.id).subscribe(
                () => {
                  this.closeDialog(true);
                }, (err1: string) => {
                  this.gmService.openErrorSnackbar(err1);
                }
            );
          } else {
// NO IMAGE
            this.closeDialog(true);
          }
        }, (error: string) => {
          this.gmService.openErrorSnackbar(error);
        }
    )
  }

  assignBattExpDate(beginDate: Date) {
    this.data.productItem.daeAttributes.daeBatteryExpireDate = (beginDate !== null) ? new Date(beginDate) : undefined;
  }

  assignElectExpDate(beginDate: Date) {
    this.data.productItem.daeAttributes.daeElectrodeExpireDate = (beginDate !== null) ? new Date(beginDate) : undefined;
  }

  productTypeChanged(newProductType: ProductType) {
    if (newProductType.moving) {
      this.disableLocationLatLon = true;

      this.data.productItem.latitude = undefined;
      this.data.productItem.longitude = undefined;

    } else {
      this.disableLocationLatLon = false;
    }
    if (!newProductType.monitored) {
      this.data.productItem.hasDae = false;
      this.data.productItem.isE015 = false;
      this.data.productItem.useChirpstack = false;
    }
  }
}

/*--------------------------------
CHANGE PRODUCTITEM OWNER COMPONENT
-------------------------------*/

@Component({
templateUrl: 'change-productItem-owner-dialog.html',
selector: 'app-change-productItem-owner-dialog',
styleUrls: ['../common/dialog-style.css']
})
export class ChangeCustomerProductItemOwnerDialogComponent extends BaseDialogComponent<ChangeCustomerProductItemOwnerDialogComponent> {

  parentId?: string;
  parentCustomer?: Customer;
  filteredCustomers?: Observable<any>;
  customerSelectionControl = new FormControl('');
  private customerProductItemService = inject(CustomerProductItemService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.parentId = data.selectedCustomer?.id;
    this.filterCustomer_init()
  }

//------
// Filterable customer List
//------
  filterCustomer_init() {
    this.filteredCustomers = this.customerSelectionControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const title = typeof value === 'string' ? value : (value as unknown as Customer).title;
          return title ? this._filter(title as string) : this.data.allCustomers!.slice()
        }),
    );
  }

  private _filter(value: string): Customer[] {
    const filterValue = value.toLowerCase();
    return this.data.allCustomers!.filter((x: Customer) => x.title.toLowerCase().includes(filterValue));
  }

  displayFn(customer: Customer): string {
    return customer ? customer.title : '';
  }

  checkSelection(): boolean {
    if(typeof this.customerSelectionControl.value != 'object') {
      return !!this.customerSelectionControl.value;
    } else {
      return false;
    }
  }

//------

  changeProductItemOwner() {

    if (this.parentId) {
      const cb = new ChangeProductItemOwnerCB();
      cb.i.id = this.data.productItem.id;
      cb.i.newOwnerId = this.parentId;

      this.customerProductItemService.changeProductItemOwner(cb).subscribe(
          () => {
            this.closeDialog(true);
          }, (error: string) => {
            this.gmService.openErrorSnackbar(error);
          }
      );
    }

  }
}



/*----------------------------------
CHANGE WORKFLOW STATUS COMPONENT
---------------------------------*/

@Component({
templateUrl: 'change-workflow-status-dialog.html',
selector: 'app-change-workflow-status-dialog',
styleUrls: ['../common/dialog-style.css']
})
export class ChangeWorkflowStatusDialogComponent extends BaseDialogComponent<ChangeWorkflowStatusDialogComponent> {

  private customerProductItemService = inject(CustomerProductItemService);

  registryStatusEnum = RegistryStatusEnum;

  selectedRegistryStatus: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: CustomerProductItemFull) {
    super();
    this.selectedRegistryStatus = data.registryStatus;
  }

  changeWorkflowStatus() {
    const cb = new PutCustomerProductItemRegistryStatusCB();

    if (!!this.selectedRegistryStatus) {
      cb.i.id = this.data.id;
      cb.i.registryStatus = this.selectedRegistryStatus;

      this.customerProductItemService.putCustomerProductItemRegistryStatus(cb).subscribe(
          () => {
            this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.CHANGE_WORKFLOW_STATUS_OK'));
            this.closeDialog(true);
          }, (error: string) => {
            this.gmService.openErrorSnackbar(error);
          }
      );
    }

  }
}


/*--------------------------------
DELETE PRODUCTITEM COMPONENT
-------------------------------*/

@Component({
templateUrl: '../common/are-u-sure-delete-dialog.html',
selector: 'app-are-u-sure-delete-dialog',
styleUrls: ['../common/dialog-style.css']
})
export class AreUSureDeleteProductItemDialogComponent extends BaseDialogComponent<AreUSureDeleteProductItemDialogComponent> {

  entity = "Installazione";


  constructor(@Inject(MAT_DIALOG_DATA) public customerTitle: string) {
    super();
  }

}

/*--------------------------------
PRODUCTITEM TOKEN COMPONENT
-------------------------------*/

@Component({
templateUrl: 'show-or-update-token-dialog.html',
selector: 'app-show-or-update-token-dialog',
styleUrls: ['../common/dialog-style.css']
})
export class ProductItemTokenDialogComponent extends BaseDialogComponent<ProductItemTokenDialogComponent> {

  private customerProductItemService = inject(CustomerProductItemService);
  newToken = "";
  editMode = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.newToken = data.token;
  }

  copiedToken() {
    this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.TOKEN_COPIED'));
  }

  changeProductItemToken() {

    const cb = new ChangeProductItemTokenCB();
    cb.i.id = this.data.productItem.id;
    cb.i.newProductItemToken = this.newToken;

    this.customerProductItemService.changeProductItemToken(cb).subscribe(
        () => {
          this.data.token = this.newToken;
          this.gmService.openTranslatedSuccessSnackbar('PRODUCTITEM.UPDATE_OK');
        }, (error: string) => {
          this.gmService.openErrorSnackbar(error);
        }
    );
  }

}
